import ResultsCustomOutput from './resultsCustomOutput.js';
export default ResultsCustomOutput;
